import { Reducer } from 'redux';
import { IAction } from '../types';
import { localKeyInfo } from '../config';
import LocalStore from '@/utils/store';

export interface OnlineInfoState {
  list: any[];
  state: number;
  userId: number;
  roomId: number;
  roomName: string;
  roomTime: number;
}

const LOCALKEY = localKeyInfo.onlineInfo;
const localVoiceInfo = LocalStore.getValue<OnlineInfoState>(LOCALKEY) || {};

export const onlineInfo: OnlineInfoState = {
  list: [],
  state: 0,
  userId: 0,
  roomId: 0,
  roomName: '',
  roomTime: 0,
  ...localVoiceInfo
};

export const setOnlineInfo: (payload: OnlineInfoState) => IAction<OnlineInfoState> = (payload: OnlineInfoState) => ({
  type: 'setOnlineInfo',
  payload
});

const onlineInfoReducer: Reducer<OnlineInfoState, IAction<any>> = (state = onlineInfo, action: IAction<any>) => {
  const { type, payload } = action;
  switch (type) {
    case 'setOnlineInfo':
      LocalStore.setValue(LOCALKEY, payload);
      return {
        ...payload
      };
    default:
      return state;
  }
};

export default onlineInfoReducer;
